// extracted by mini-css-extract-plugin
export default {"box":"advertisementFilterPage_box__zdeLb","box__content":"advertisementFilterPage_box__content__6x51j","box__btn":"advertisementFilterPage_box__btn__tuRHi"};